export class Status
{
    id: number; 
    status: string;
}